module.exports = __webpack_public_path__ + "img/聚焦时尚p.e55dac8c.png";